import { JobPosition } from '../../../domain/graphcms';
import { JobApplication } from '../../../services/dtos';
import { Lead } from '../../../services/dtos/lead';
import { TrackingEvent, sendEvent } from '../../services/tracking/tracking';
import { hash } from '../crypto/sha256';
import {
  EVALUATION_LEAD_AS,
  EVALUATION_LEAD_URL,
  EVALUATION_THANK_YOU_AS,
  EVALUATION_THANK_YOU_URL,
  THANK_YOU_AS,
  THANK_YOU_URL,
  URLObject,
  goToPage,
} from '../links';

export function sendEventAndRedirect<T extends TrackingEvent>(event: string, params: T, redirectOpts?: { urlObject: URLObject, replace?: boolean }) {
  sendEvent(event, params);

  if (redirectOpts) {
    goToPage(redirectOpts.urlObject, redirectOpts.replace);
  }
}

async function sendLeadSubmitEventWithRedirection(label: string, lead: Lead, urlObject: URLObject) {
  const event = 'lead_submit';
  const [formPosition, formName] = label.split(':');
  const [emailSha256, phoneNumberSha256] = await Promise.all([
    hash(lead.email),
    hash(lead.phoneNumber),
  ]);
  const params = {
    category: 'lead',
    action: 'submit',
    label,
    formName,
    formPosition,
    leadId: lead.id,
    source: lead.source,
    email: lead.email,
    emailSha256,
    phoneNumber: lead.phoneNumber,
    phoneNumberSha256,
    locality: lead.locality,
    zipCode: lead.postalCode,
  };

  return sendEventAndRedirect(event, params, { urlObject });
}

export async function sendLeadSubmitEventAndRedirect(label: string, lead: Lead) {
  return sendLeadSubmitEventWithRedirection(label, lead, {
    url: THANK_YOU_URL,
    as: THANK_YOU_AS,
  });
}

export async function sendEvaluationLeadSubmitEventAndRedirect(label: string, lead: Lead) {
  return sendLeadSubmitEventWithRedirection(label, lead, {
    url: EVALUATION_THANK_YOU_URL,
    as: EVALUATION_THANK_YOU_AS,
  });
}

export function sendEvaluationFormSubmitEventAndRedirect(label: string) {
  return sendEventAndRedirect('form_submit', {
    category: 'form',
    action: 'submit',
    label,
  }, {
    urlObject: {
      url: EVALUATION_LEAD_URL,
      as: EVALUATION_LEAD_AS,
    },
  });
}

export function sendJobApplicationSubmitEvent(
  label: string,
  jobApplication: JobApplication,
  jobPosition: JobPosition,
  redirectOpts?: { urlObject: URLObject, replace?: boolean },
) {
  const event = 'job_application_submit';
  const params: TrackingEvent = {
    category: 'job-application',
    action: 'submit',
    label,
    jobApplicationId: jobApplication.id,
    source: jobApplication.source,
    email: jobApplication.email,
    phoneNumber: jobApplication.phoneNumber,
    province: jobApplication.province,
    jobPositionId: jobPosition.id,
    jobPositionDepartment: jobPosition.department,
    jobPositionName: jobPosition.name,
  };

  return sendEventAndRedirect(event, params, redirectOpts);
}
